import React from 'react';
import { IMailingList } from "./MailingListItem";
import * as toast from '../../toast';
import PciStatusAlert from "../PciStatusAlert";

interface IMailingListUpdateProps {
    MailingLists: Array<IMailingList>;
    UpdateSubscribedLists: (lists: Array<IMailingList>) => void;
    Disabled?: boolean;
}

interface State {
    isSaving: boolean;
    confirmationRequired: boolean;
}

export default class MailingListUpdate extends React.Component<IMailingListUpdateProps, State> {
    constructor(props: IMailingListUpdateProps) {
        super(props);
        this.state = { isSaving: false, confirmationRequired: false };
    }

    private SaveUpdates(subscribedLists: Array<IMailingList>) {
        if (this.props.Disabled || this.state.isSaving || this.state.confirmationRequired)
            return;

        const updateLists = subscribedLists.map(list => ({
            active: list.active,
            listCategory: list.listCategory,
            listDescription: list.listDescription,
            listName: list.listName,
            listTitle: list.listTitle
        }));

        this.setState({ isSaving: true });
        $.ajax({
            url: "/api/MailingLists/UpdateMailingLists",
            type: "POST",
            data: JSON.stringify(updateLists),
            dataType: "json",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        }).done((updatedLists: Array<IMailingList>) => {
            if (!Array.isArray(updatedLists)) {
                this.setState({ isSaving: false, confirmationRequired: true });
                return;
            }

            this.props.UpdateSubscribedLists(updatedLists);
            this.setState({ isSaving: false });
            toast.Toast.Display('Your subscriptions have been updated');
        }).fail(() => {
            this.setState({ isSaving: false, confirmationRequired: true });
            toast.Toast.Display('There was an error updating your subscriptions', null, 'error');
        });
    }

    public OnUpdateLists(event: React.FormEvent<HTMLButtonElement>) {
        event.preventDefault();
        this.SaveUpdates(this.props.MailingLists.filter(list => list.subscribe));
    }

    public render() {
        const isDisabled = this.props.Disabled || this.state.isSaving || this.state.confirmationRequired;

        return (
            <div className="mailing-list-update">
                {this.state.confirmationRequired && (
                    <PciStatusAlert tone="warning"
                        heading="Subscription update not confirmed"
                        message="PCI did not confirm whether this change was applied. Your edits have been kept, but another save is disabled. Refresh the page to verify your subscriptions before trying again." />
                )}
                <button className="btn btn-primary pull-right" disabled={isDisabled}
                    onClick={event => this.OnUpdateLists(event)}>
                    {this.state.isSaving ? "Saving..." : "Save Changes"}
                </button>
            </div>
        );
    }
}
